import { useGetRepositoryOpenGrepRules, useGetRepositoryOpenGrepRulesContent } from '../utils/api-client/api-hooks.ts'

export function useOpenGrepRulesContent({ repositoryId, enabled = true }: { repositoryId: string; enabled?: boolean }) {
  const { data: openGrepRules, isLoading: isRulesLoading } = useGetRepositoryOpenGrepRules({
    repositoryId,
    enabled,
  })
  const hasContentLink = !!openGrepRules?._links.content
  const { data: content, isLoading: isContentLoading } = useGetRepositoryOpenGrepRulesContent({
    repositoryId,
    generatedAt: openGrepRules?.generatedAt,
    enabled: enabled && hasContentLink,
  })
  return { openGrepRules, isRulesLoading, content, isContentLoading }
}
